(function() {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('audits', {
            parent: 'admin',
            url: '/audits?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'audits.title'
            },
            views: {
                'content@main': {
                    templateUrl: 'app/admin/audits/audits.html',
                    controller: 'AuditsController',
                    controllerAs: 'vm'
                }
            },
            params:{
                page: {
                    value: '1',
                    squash: true
                },
                sort:{
                    squash:true
                },
                toDate: {
                    value:
                        (function today(){
                            return new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 1);
                        }),
                    squash: true
                },
                fromDate: {
                    value:
                        (function previousMonth(){
                            var fromDate = new Date();
                            if (fromDate.getMonth() === 0) {
                                return new Date(fromDate.getFullYear()-1, 11, fromDate.getMonth());
                            } else {
                                return new Date(fromDate.getFullYear(), fromDate.getMonth()-1, fromDate.getDate());
                            }
                        }),
                    squash: true
                },
                filter: {
                    value: {activity: ''},
                    squash: true
                },
                predicates :{},
                search: {
                    value: '',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        predicates : $stateParams.predicates,
                        search: $stateParams.search,
                        toDate: $stateParams.toDate,
                        fromDate: $stateParams.fromDate,
                        sort: $stateParams.sort,
                        filter: $stateParams.filter,
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('audits');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
